import { Controller } from "@hotwired/stimulus";

// Utilisation :
// <button data-controller="copy-to-clipboard" data-action="click->copy-to-clipboard#copy" data-copy-to-clipboard-target="source" data-copy-to-clipboard-content-value="...">Copier</button>
// OU
// <button data-controller="copy-to-clipboard" data-action="click->copy-to-clipboard#copy" data-copy-to-clipboard-target="source">Copier</button>
// <div data-copy-to-clipboard-target="source">Texte à copier</div>

export default class extends Controller {
  static targets = ["source"];
  static values = { content: String, sourceId: String };

  copy(event) {
    event.preventDefault();
    let text = this.contentValue;
    let html = null;

    if (this.hasSourceIdValue) {
      const el = document.getElementById(this.sourceIdValue);
      if (el && el.innerHTML.trim() !== "") {
        html = el.innerHTML;
      } else {
        if (window.showToast) {
          window.showToast({ detail: { message: "Aucune signature disponible" } });
        }
        return;
      }
    } else if (this.hasSourceTarget) {
      const el = this.sourceTarget;
      if (el.innerHTML && el.innerHTML.trim() !== "") {
        if (el.tagName === "IMG" || el.querySelector("img")) {
          html = el.innerHTML;
        } else {
          text = el.value || el.textContent || el.innerText;
        }
      } else {
        if (window.showToast) {
          window.showToast({ detail: { message: "Aucune signature disponible" } });
        }
        return;
      }
    }

    if (!text && !html) return;

    if (html) {
      const item = new ClipboardItem({
        "text/html": new Blob([html], { type: "text/html" })
      });
      navigator.clipboard.write([item]).then(() => {
        if (window.showToast) {
          window.showToast({ detail: { message: "Signature copiée !" } });
        } else {
          this.showFeedback();
        }
      }).catch(err => {
        console.error('Erreur lors de la copie:', err);
        if (window.showToast) {
          window.showToast({ detail: { message: "Erreur lors de la copie" } });
        }
      });
    } else {
      navigator.clipboard.writeText(text).then(() => {
        if (window.showToast) {
          window.showToast({ detail: { message: "Copié !" } });
        } else {
          this.showFeedback();
        }
      }).catch(err => {
        console.error('Erreur lors de la copie:', err);
        if (window.showToast) {
          window.showToast({ detail: { message: "Erreur lors de la copie" } });
        }
      });
    }
  }

  showFeedback() {
    // Fallback : feedback visuel sur le bouton
    if (this.element.tagName === "BUTTON" || this.element.tagName === "INPUT") {
      const original = this.element.textContent;
      this.element.textContent = "Copié !";
      setTimeout(() => {
        this.element.textContent = original;
      }, 1000);
    }
  }
} 